import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DataLayerTypeStore } from '../../../stores/data-layer-type/data-layer-type.state';
import { DataLayerType } from '../../../models/data-layer-type';
import { PickList, PickListModule } from 'primeng/picklist';
import { GeoDataStore } from '../../../stores/geo/geo-data.state';
import { NgIf } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { SvgIconComponent } from '../../atoms/svg-icon/svg-icon.component';
import { AlertComponent } from '../../atoms/alert/alert.component';

@Component({
  selector: 'app-data-layer-type-pick-list',
  standalone: true,
  imports: [PickListModule, NgIf, SvgIconComponent, AlertComponent],
  templateUrl: './data-layer-type-pick-list.component.html',
  styleUrl: './data-layer-type-pick-list.component.scss',
})
export class DataLayerTypePickListComponent implements OnInit, OnDestroy {
  readonly geoStore = inject(GeoDataStore);
  readonly layerStore = inject(DataLayerStore);
  readonly dataLayerTypeStore = inject(DataLayerTypeStore);

  @ViewChild('listPickerCtrl') listPickerCtrl!: PickList;
  @Input() type: 'Point' | 'Polygon' = 'Polygon';
  @Input() addGroups = true;

  @Input() selectedIds: string[] = [];
  @Input() selectedGroups?: Record<string, string[]>;
  @Input() ignoreChildren = false;
  @Input() keepSelection = false;
  @Input() showSourceControls = false;
  @Input() showTargetControls = true;
  @Output() selectionChanged = new EventEmitter<string[]>();

  selected: MenuItem[] = [];
  groups: string[] = [];
  geoDataId = '';
  items: MenuItem[] = [];

  /**
   * Angular lifecycle hook that is called after the component has been initialized.
   * It sets the `selected` property to the current selection from the dataLayerType store.
   *
   * @return {void} Does not return a value.
   */
  ngOnInit(): void {
    this.setItems();
  }

  /**
   * Todo: refactor
   * Populates a list of items based on the layer types and their associated groups.
   *
   * This method determines the appropriate data layer types (point or polygon) based on the
   * current type and iterates through them. For each type, it retrieves the associated geo data ID
   * and groups. If groups are present, it creates an item for each group; otherwise, it creates
   * a single item for the type itself.
   *
   * @return {void} This method does not return any value.
   */
  setItems(): void {
    console.log('selectedIds:', this.selectedIds);
    const types =
      this.type === 'Point'
        ? this.dataLayerTypeStore.pointLayers()
        : this.dataLayerTypeStore.polygonLayers();
    types.forEach((type: DataLayerType) => {
      const selectedGroups = this.selectedGroups?.[type._id] || [];
      this.geoDataId = this.layerStore.getGeoDataIdFromSiblings(type._id);
      this.groups = this.geoStore.getGroupsById(this.geoDataId) || [];

      if (this.groups && this.groups.length > 0) {
        this.groups.forEach((group: string) => {
          if (selectedGroups.includes(group)) {
            this.selected.push({
              label: `${type.name}: ${group}`,
              id: `${type._id}#${group}`,
              icon: type.icon || 'fas fa-circle-nodes',
            });
          } else {
            this.items.push({
              label: `${type.name}: ${group}`,
              id: `${type._id}#${group}`,
              icon: type.icon || 'fas fa-circle-nodes',
            });
          }
        });
      } else {
        if (this.selectedIds.includes(type._id)) {
          this.selected.push({
            label: type.name,
            id: type._id,
            icon: type.icon || 'fas fa-map',
          });
        } else {
          this.items.push({
            label: type.name,
            id: type._id,
            icon: type.icon || 'fas fa-map',
          });
        }
      }
    });

    console.log('selected', this.selected);
  }

  /**
   * Updates the selection of items in the dataLayerType store and, if autoselectParents is enabled, adds parent items to the selection and updates the local selection state.
   *
   * @return {void} This method does not return a value.
   */
  updateSelection(): void {
    //this.dataLayerTypeStore.updateSelection(this.selected);
    //this.selected = this.dataLayerTypeStore.selection();

    console.log('this.selected', this.selected);
    this.selectionChanged.emit(this.selected.map(item => item.id || ''));
  }

  /**
   * A lifecycle hook that is called when the component is destroyed.
   * This method checks the `keepSelection` property and, if it is false, clears the selection in the dataLayerType store.
   *
   * @return {void} Does not return a value.
   */
  ngOnDestroy(): void {
    if (this.keepSelection) return;
    this.dataLayerTypeStore.clearSelection();
  }
}
